import React from 'react';
import cal1 from '../../../images/carousel/school-1.png';
import cal2 from '../../../images/carousel/perfume-3.png';
import cal3 from '../../../images/carousel/doctor-3.png';
import cal4 from '../../../images/carousel/travel-1.png';
import cal5 from '../../../images/carousel/cart-2.png';
import cal6 from '../../../images/carousel/hotel-4.png';
import cal7 from '../../../images/carousel/doctor-2.png';
import cal8 from '../../../images/carousel/perfume-2.png';
import cal9 from '../../../images/carousel/book-2.png';
import { Carousel, Container } from 'react-bootstrap';
import { useSpring, animated } from "react-spring";
import './HomeProjects.css';

  const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
  const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`



const HomeProjects = () => {

    const [props, set] = useSpring(() => ({
    xys: [0, 0, 1],
    config: {
      mass: 5, tension: 350, friction: 40
    }
  }))

    
  return (
    <div className='home-carol'>
      <Container>
          <div className='services-dot'>
            <h2>PORTFOLIO</h2>
              <h3>.</h3>
          </div>
          <p className='serv-p p-2'>My Project</p>
      <Carousel variant="dark">
      <Carousel.Item interval={1000}>
      <div className='d-flex'>

      <animated.div
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card'>
          <img src={cal1} alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>LearningSchool</h3>
          <p>Learning School related only. School learning is the acquisition of knowledge, subject matter...</p>
          <a href="https://learning-school-bcec1.web.app"><button>SEE PROJECT</button></a>
        </div>
      </animated.div>


      <animated.div
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card mx-3'>
          <img src={cal2} alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>PerfumePride</h3>
          <p>This website has two dashboards -user and admin. Admin Dashboard - Manage All Orders, Add...</p>
          <a href="https://assignment12-5175d.web.app"><button>SEE PROJECT</button></a>
        </div>
      </animated.div>


      <animated.div
      // className="card"
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card'>
          <img src={cal3} alt="..."/>
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>HealthCare</h3>
          <p>This website is usually about medical services, healthcare, medical teams, appointments...</p>
          <a href="https://lifeline-medical.web.app"><button>SEE PROJECT</button></a>
        </div>
        </animated.div>
      </div>
      </Carousel.Item>
      <Carousel.Item interval={500}>

    <div className='d-flex'>

      <animated.div
      // className="card"
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card'>
          <img src={cal4} alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>Your.Travel</h3>
          <p>This website is travel agency related website. This website we can know all kinds of information about travel...</p>
          <a href="https://assignment-6-gates-843127.netlify.app/"><button>SEE PROJECT</button></a>
        </div>
      </animated.div>
      
      <animated.div
      // className="card"
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card mx-3'>
          <img src={cal5} alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>Add Cart Project</h3>
          <p>It is basically an online teaching website for cart. It is basically an online website for cart...</p>
          <a href="https://assignment-7-awesome-hoover-a8e7f3.netlify.app"><button>SEE PROJECT</button></a>
        </div>
      </animated.div>

      <animated.div
      // className="card"
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >        
        <div className='carol-card'>
          <img src={cal6} alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>Hotel Tourism</h3>
          <p>Tourism-related website.Through this website, users can get any hotel service. Click on Booking Now...</p>
          <a href="https://react-firebase-authentic-babb0.web.app/"><button>SEE PROJECT</button></a>
        </div>
        </animated.div>  
      </div>
      </Carousel.Item>


      <Carousel.Item>

      <div className='d-flex'>

      <animated.div
      // className="card"
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card'>
          <img src={cal7}  alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>HealthCare</h3>
          <p>This website is usually about medical services, healthcare, medical teams,appointments...</p>
          <a href="https://lifeline-medical.web.app"><button>SEE PROJECT</button></a>
        </div>
      </animated.div>



      <animated.div
      // className="card"
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card mx-3'>
          <img src={cal8} alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>Chef Journey</h3>
          <p>This is an single page website.Concept was invented in the Chef Journey.We can add through this website...</p>
          <a href="https://assignment-8-musing-gates-471b6f.netlify.app/"><button>SEE PROJECT</button></a>
        </div>
      </animated.div>


      <animated.div
      // className="card"
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: props.xys.interpolate(trans) }}
      >
        <div className='carol-card '>
          <img src={cal9} alt="..." />
          <h6 className='mt-4'>Frontend Development/Web Design</h6>
          <h3>Book Archives</h3>
          <p>This website is for book search only. And get it here. Be it Bengali,English, Java, JavaScript...</p>
          <a href="https://assignment-6-gates-843127.netlify.app/"><button>SEE PROJECT</button></a>
        </div>
      </animated.div>
      </div>
      </Carousel.Item>
    </Carousel>
    </Container>
        </div>
    );
};

export default HomeProjects;